module.exports = __webpack_public_path__ + "img/api.60cce029.jpg";